/*
 * Cabecera TecPro Campo. Sin dependencias.
 * Sin JavaScript la cabecera sigue completa y navegable: solo pierde la
 * versión compacta al bajar y el cierre con Escape del menú de celular.
 */
(function () {
  var cabecera = document.querySelector('[data-tpc-cab]');
  if (!cabecera) return;

  var envoltura = cabecera.closest('.tpc-cab-seccion') || cabecera.parentElement;
  var movil = cabecera.querySelector('[data-tpc-movil]');
  var raiz = document.documentElement;
  var UMBRAL_BAJAR = 60;
  var UMBRAL_SUBIR = 12;
  var compacta = false;
  var pendiente = false;

  /* La envoltura reserva la altura de la cabecera en reposo. Así, al compactarse,
     el contenido de la página no salta hacia arriba. */
  function reservarAltura() {
    var estabaCompacta = cabecera.hasAttribute('data-compacta');
    cabecera.removeAttribute('data-compacta');
    envoltura.style.minHeight = '';
    envoltura.style.minHeight = cabecera.offsetHeight + 'px';
    if (estabaCompacta) cabecera.setAttribute('data-compacta', '');
  }

  function revisarScroll() {
    pendiente = false;
    var y = window.scrollY || raiz.scrollTop;
    if (!compacta && y > UMBRAL_BAJAR) {
      compacta = true;
      cabecera.setAttribute('data-compacta', '');
    } else if (compacta && y < UMBRAL_SUBIR) {
      compacta = false;
      cabecera.removeAttribute('data-compacta');
    }
  }

  function alDesplazar() {
    if (pendiente) return;
    pendiente = true;
    window.requestAnimationFrame(revisarScroll);
  }

  function ubicarPanel() {
    if (!movil) return;
    movil.style.setProperty('--tpc-panel-arriba', Math.round(cabecera.getBoundingClientRect().bottom) + 'px');
  }

  function cerrarMenu() {
    if (!movil || !movil.open) return;
    movil.open = false;
    var boton = movil.querySelector('summary');
    if (boton) boton.focus();
  }

  if (movil) {
    movil.addEventListener('toggle', function () {
      raiz.classList.toggle('tpc-menu-abierto', movil.open);
      if (movil.open) ubicarPanel();
    });
  }

  document.addEventListener('keydown', function (evento) {
    if (evento.key === 'Escape') cerrarMenu();
  });

  window.addEventListener('scroll', alDesplazar, { passive: true });
  window.addEventListener('resize', function () {
    reservarAltura();
    if (movil && movil.open && window.innerWidth > 900) cerrarMenu();
    else ubicarPanel();
  });

  reservarAltura();
  revisarScroll();
  window.addEventListener('load', reservarAltura);
})();
